import axios from "axios";
import router from "../router";

const baseUrl = require("../util/baseUrl");

let URL = baseUrl.baseurl();
let token = localStorage.getItem("token");
let refresh_token = localStorage.getItem("refresh_token");

export const api = axios.create({
  baseURL: `${URL}`
});

export const tokenlogin = () => {
  return api.post(`/tokenLoginAdmin`, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const refreshToken = () => {
  return api.post(`/genLoginTokenAdmin`, {
    headers: { Authorization: `Bearer ${refresh_token}` }
  });
};

export const login = async (email, password) => {
  let res = await api.post(`/loginAdmin`, {
    email: email,
    password: password
  });
  api.defaults.headers.common["Authorization"] = `Bearer ${res.data.token}`;
  return res;
};

export const logout = () => {
  api.post(`/logoutAdmin`);
  return delete api.defaults.headers.common.Authorization;
};

export const getAllCurriculum = () => {
  return api.get(`/getCurriculumTable`);
};

export const getCourseTable = (id, query = "public=true") => {
  return api.get(`/getCourseTable?curriculum_id=${id}&${query}`);
};

export const getVideoTable = (id, query = "public=true") => {
  return api.get(`/getVideoTable?course_id=${id}&${query}`);
};

export const getCurriculumtype = () => {
  return api.get(`/getCurriculumCateTable`);
};

export const getorganization = () => {
  return api.get(`/getOrganizationTable`);
};

export const getLecturerTable = () => {
  return api.get(`/getLecturerTable`);
};

export const getBannerTable = (query = "public=true") => {
  return api.get(`/getBannerTable?${query}`);
};

export const getPaymentTable = () => {
  return api.get(`/getPaymentTable`);
};

export const getUserTable = () => {
  return api.get(`/getUserTable`);
};

export const getAdminTable = () => {
  return api.get(`/getAdminTable`);
};

///choice api ////

export const organization_choice = () => {
  return api.get(`/getAllOrganization`);
};

export const curriculumtype_choice = () => {
  return api.get(`/getAllCategory_curriculum`);
};

export const getAllLecturer = () => {
  return api.get(`/getAllLecturer`);
};

///////get data by id/////////

export const getcurriculum_byid = id => {
  return api.get(`/getCurriculumAdmin?curriculum_id=${id}`);
};

export const getcourse_byid = id => {
  return api.get(`/getCourseAdmin?course_id=${id}`);
};

export const getlecturer_byid = id => {
  return api.get(`/getLecturerAdmin?lecturer_id=${id}`);
};

export const getlecturer_withtable = id => {
  return api.get(`/getLecturerDetailTable?lecturer_id=${id}`);
};

export const getuser_withtable = id => {
  return api.get(`/getUserDetailTable?user_id=${id}`);
};

export const getcurriculumType_byid = id => {
  return api.get(`/getCategoryCurriculumAdmin?category_curriculum_id=${id}`);
};

export const getvideo_byid = id => {
  return api.get(`/getVideoAdmin?video_id=${id}`);
};

export const getorganization_byid = id => {
  return api.get(`/getOrganizationAdmin?organization_id=${id}`);
};

export const getbanner_byid = id => {
  return api.get(`/getBannerById?banner_id=${id}`);
};

export const getAdmin_byid = id => {
  return api.get(`/getAdminDetail?admin_id=${id}`);
};

export const getCountdown = () => {
  return api.get(`getCountdownAdmin`);
};

api.interceptors.request.use(
  async config => {
    config.headers = {
      Authorization: `Bearer ${localStorage.getItem("token")}`
    };
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

api.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    let originalRequest = error.config;
    if (
      error.response.status === 401 &&
      error.response.data.error == "jwt expired" &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;
      let refresh_token_now = localStorage.getItem("refresh_token");
      let config = {
        method: "post",
        url: `${URL}/genLoginTokenAdmin`,
        headers: { Authorization: `Bearer ${refresh_token_now}` }
      };
      axios(config)
        .then(async res => {
          console.log(res.data);
          await localStorage.setItem("token", res.data.token);
          error.config.headers["Authorization"] =
            "Bearer " + `${res.data.token}`;
          return axios(originalRequest);
        })
        .catch(err => {
          return router.push({ path: "/pages/login" });
        });
    } else if (
      error.response.status === 401 &&
      error.response.data.error == "Invalid token"
    ) {
      return router.push({ path: "/pages/login" });
    } else if (
      error.response.status === 401 &&
      error.response.data.error == "jwt malformed"
    ) {
      return router.push({ path: "/pages/login" });
    }
    return Promise.reject(error);
  }
);

let apis = {
  api,
  login,
  logout,
  getAllCurriculum,
  getCurriculumtype,
  getorganization,
  organization_choice,
  curriculumtype_choice,
  getAllLecturer,
  getCourseTable,
  getVideoTable,
  getLecturerTable,
  getlecturer_withtable,
  getBannerTable,
  getPaymentTable,
  getUserTable,
  getuser_withtable,
  getAdminTable,

  getcurriculum_byid,
  getlecturer_byid,
  getcourse_byid,
  getcurriculumType_byid,
  getvideo_byid,
  getorganization_byid,
  getbanner_byid,
  getAdmin_byid,
  getAdmin_byid,

  getCountdown,
  tokenlogin,
  refreshToken
};

export default apis;
